// extracted by css-extract-rspack-plugin
export default {"host":"src-domain-components-module-cancel-modal-CancelModal-module__host-TbDxWP","paper":"src-domain-components-module-cancel-modal-CancelModal-module__paper-pJkVfQ","actions":"src-domain-components-module-cancel-modal-CancelModal-module__actions-uJpqJ7","title":"src-domain-components-module-cancel-modal-CancelModal-module__title-XvZ379","header":"src-domain-components-module-cancel-modal-CancelModal-module__header-LGnbHe"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"host\":\"src-domain-components-module-cancel-modal-CancelModal-module__host-TbDxWP\",\"paper\":\"src-domain-components-module-cancel-modal-CancelModal-module__paper-pJkVfQ\",\"actions\":\"src-domain-components-module-cancel-modal-CancelModal-module__actions-uJpqJ7\",\"title\":\"src-domain-components-module-cancel-modal-CancelModal-module__title-XvZ379\",\"header\":\"src-domain-components-module-cancel-modal-CancelModal-module__header-LGnbHe\"}";
        // 1793705032646
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  